import * as React from 'react';
import { Entry } from 'contentful';

import styled from '../../../theme';
import { IProjectContent } from '../../../models/Project';
import VideoOrImage from './VideoOrImage';

interface IProps {
  projectContent: Entry<IProjectContent>;
  containerWidth: number;
}

const Container = styled.div`
  > * {
    width: 100%;
    display: inline-block;
    margin: 0 auto;
  }

  @media (max-width: ${props => props.theme.mobileBreakpoint - 1}px) {
    padding: 0 ${props => props.theme.mobilePadding}px;
  }

  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    > * {
      width: 60%;
    }

    text-align: center;
  }
`;

const OneHalf = React.memo<IProps>(({ projectContent, containerWidth }) => (
  <Container>
    <VideoOrImage projectContent={projectContent} />
  </Container>
));

export default OneHalf;



// WEBPACK FOOTER //
// ./src/scenes/Project/ProjectContent/OneHalf.tsx